module.exports = __webpack_public_path__ + "officialStatic/img/case-fsk.e17aeba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-fsk.png
// module id = bXJc
// module chunks = 0